// extracted by mini-css-extract-plugin
module.exports = {"passion":"Passion_passion__1LSEu","title":"Passion_title__1waai","isActive":"Passion_isActive__2Xq0h","passionCover":"Passion_passionCover__1e6aH"};